/* HOMEARENA landing behaviours: reveal, sticky buy bar, variant sync,
   countdown, video pause off-screen. No dependencies. */
(function () {
  'use strict';

  var root = document.documentElement;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- reveal on scroll ---------- */
  function initReveal(scope) {
    if (!root.hasAttribute('data-ha-reveal-enabled') || designMode || reduceMotion || !hasIO) return;
    root.classList.add('ha-reveal-on');
    var els = (scope || document).querySelectorAll('[data-ha-reveal]:not(.is-in)');
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
    // Safety net: never leave content hidden.
    setTimeout(function () {
      document.querySelectorAll('[data-ha-reveal]:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('is-in');
      });
    }, 2500);
  }

  /* ---------- sticky buy bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-ha-sticky]');
    if (!bar) return;
    if (designMode && bar.hasAttribute('data-ha-sticky-editor')) {
      bar.classList.add('is-visible');
      return;
    }
    var hero = document.querySelector('[data-ha-hero]');
    var buy = document.querySelector('[data-ha-buycard]');
    var footer = document.querySelector('.ha-footer');
    var state = { pastHero: !hero, buyVisible: false, footerVisible: false };

    function render() {
      var show = state.pastHero && !state.buyVisible && !state.footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a, button, input, select').forEach(function (el) {
        if (show) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    }

    if (!hasIO) {
      state.pastHero = true;
      render();
      return;
    }

    if (hero) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        state.pastHero = !e.isIntersecting && e.boundingClientRect.top < 0;
        render();
      }).observe(hero);
    }
    if (buy) {
      new IntersectionObserver(
        function (entries) {
          state.buyVisible = entries[0].isIntersecting;
          render();
        },
        { threshold: 0.25 }
      ).observe(buy);
    }
    if (footer && bar.hasAttribute('data-ha-hide-footer')) {
      new IntersectionObserver(function (entries) {
        state.footerVisible = entries[0].isIntersecting;
        render();
      }).observe(footer);
    }
    render();
  }

  /* ---------- variant select keeps prices + every buy form in sync ---------- */
  function initVariants() {
    document.querySelectorAll('[data-ha-variant-select]').forEach(function (select) {
      if (select.dataset.haBound) return;
      select.dataset.haBound = '1';
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        document.querySelectorAll('[data-ha-variant-input]').forEach(function (input) {
          input.value = opt.value;
        });
        document.querySelectorAll('[data-ha-price]').forEach(function (el) {
          if (opt.dataset.price) el.textContent = opt.dataset.price;
        });
        document.querySelectorAll('[data-ha-compare]').forEach(function (el) {
          var wrap = el.closest('[data-ha-compare-wrap]') || el;
          if (opt.dataset.compare) {
            el.textContent = opt.dataset.compare;
            wrap.hidden = false;
          } else {
            wrap.hidden = true;
          }
        });
        document.querySelectorAll('[data-ha-save]').forEach(function (el) {
          var wrap = el.closest('[data-ha-save-wrap]') || el;
          if (opt.dataset.save) {
            el.textContent = opt.dataset.save;
            wrap.hidden = false;
          } else {
            wrap.hidden = true;
          }
        });
        var soldOut = opt.dataset.available !== 'true';
        document.querySelectorAll('[data-ha-submit]').forEach(function (btn) {
          btn.disabled = soldOut;
          var label = btn.querySelector('[data-ha-submit-label]');
          if (label) label.textContent = soldOut ? btn.dataset.soldOut : btn.dataset.label;
        });
        updateTotals();
        if (window.history && window.history.replaceState && select.hasAttribute('data-ha-update-url')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', opt.value);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ---------- countdown ---------- */
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }
  function initCountdown() {
    document.querySelectorAll('[data-ha-countdown]').forEach(function (el) {
      if (el.dataset.haBound) return;
      var end = Date.parse(el.getAttribute('data-ha-countdown'));
      if (isNaN(end)) return;
      el.dataset.haBound = '1';
      var wrap = el.closest('[data-ha-countdown-wrap]');
      var fallback = wrap && wrap.querySelector('[data-ha-countdown-fallback]');
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          if (wrap && fallback) {
            el.hidden = true;
            fallback.hidden = false;
          }
          clearInterval(timer);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        el.textContent =
          (d > 0 ? d + (d === 1 ? ' day · ' : ' days · ') : '') +
          h + ' hrs · ' + pad(m) + ' min' + (d === 0 ? ' · ' + pad(s) + ' sec' : '');
        el.hidden = false;
        if (fallback) fallback.hidden = true;
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- pause looping videos when off-screen (saves battery) ---------- */
  function initVideos(scope) {
    if (!hasIO) return;
    (scope || document).querySelectorAll('.ha-sec video, .ha-footer video').forEach(function (video) {
      if (video.dataset.haBound) return;
      video.dataset.haBound = '1';
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      if (reduceMotion) {
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.05 }
      ).observe(video);
    });
  }

  /* ---------- money ---------- */
  function formatMoney(cents, fmt) {
    fmt = fmt || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var v = cents / 100;
    function num(n, prec, thou, dec) {
      var parts = n.toFixed(prec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts.join(dec) : parts[0];
    }
    var out;
    switch (key) {
      case 'amount_no_decimals': out = num(v, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = num(v, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = num(v, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = num(v, 2, "'", '.'); break;
      case 'amount_with_space_separator': out = num(v, 2, ' ', ','); break;
      default: out = num(v, 2, ',', '.');
    }
    out = out.replace(/([.,])00$/, '');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '');
  }

  /* ---------- add-ons + order total ---------- */
  function checkedAddons() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ha-addon]:checked'));
  }
  function mainPriceCents(form) {
    var select = form.querySelector('[data-ha-variant-select]') || document.querySelector('[data-ha-variant-select]');
    if (select) {
      var opt = select.options[select.selectedIndex];
      if (opt && opt.dataset.priceCents) return Number(opt.dataset.priceCents);
    }
    return Number(form.dataset.haPriceCents || 0);
  }
  function updateTotals() {
    var addons = checkedAddons();
    var extra = addons.reduce(function (sum, a) { return sum + Number(a.dataset.priceCents || 0); }, 0);
    document.querySelectorAll('form.ha-buy-form').forEach(function (form) {
      var wrap = form.querySelector('[data-ha-total-wrap]');
      var out = form.querySelector('[data-ha-total]');
      if (!wrap || !out) return;
      if (!addons.length) { wrap.hidden = true; return; }
      out.textContent = formatMoney(mainPriceCents(form) + extra, form.dataset.haMoneyFormat);
      wrap.hidden = false;
    });
  }
  function initAddons() {
    document.querySelectorAll('[data-ha-addon]').forEach(function (box) {
      if (box.dataset.haBound) return;
      box.dataset.haBound = '1';
      box.addEventListener('change', updateTotals);
    });
    updateTotals();
  }

  /* ---------- buy forms ---------- */
  function showError(form, msg) {
    var el = form.querySelector('[data-ha-error]');
    if (el) { el.textContent = msg; el.hidden = false; }
  }
  function setBusy(form, busy) {
    var btn = form.querySelector('[data-ha-submit]');
    if (!btn) return;
    if (busy) { btn.setAttribute('aria-busy', 'true'); btn.style.pointerEvents = 'none'; }
    else { btn.removeAttribute('aria-busy'); btn.style.pointerEvents = ''; }
  }
  function cartRoutes() {
    var r = window.routes || {};
    return {
      add: (r.cart_add_url || '/cart/add') + '.js',
      cart: r.cart_url || '/cart',
      cartJson: (r.cart_url || '/cart') + '.js'
    };
  }
  function updateCartCount() {
    fetch(cartRoutes().cartJson, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.ha-cart-count').forEach(function (el) { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
        var link = document.querySelector('.ha-header a[href*="/cart"]');
        if (link && !link.querySelector('.ha-cart-count') && cart.item_count) {
          var badge = document.createElement('span');
          badge.className = 'ha-cart-count';
          badge.setAttribute('aria-hidden', 'true');
          badge.textContent = cart.item_count;
          link.appendChild(badge);
        }
      })
      .catch(function () {});
  }
  function openDrawer(response) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && response && response.sections) {
      try {
        drawer.setActiveElement && drawer.setActiveElement(document.activeElement);
        drawer.renderContents(response);
        updateCartCount();
        return true;
      } catch (err) { /* fall through to the cart page */ }
    }
    return false;
  }
  function initForms() {
    document.querySelectorAll('form.ha-buy-form').forEach(function (form) {
      if (form.dataset.haBound) return;
      form.dataset.haBound = '1';
      var lastClicked = null;
      form.querySelectorAll('[data-ha-submit]').forEach(function (btn) {
        btn.addEventListener('click', function () { lastClicked = btn; });
      });
      form.addEventListener('submit', function (e) {
        var idInput = form.querySelector('[name="id"]');
        var submitter = e.submitter || lastClicked;
        var action = (submitter && submitter.dataset.haAction) || form.dataset.haAfter || 'checkout';
        if (action === 'link') return;
        if (!idInput || !window.fetch) return; // no JS fetch: plain form post to the cart page
        e.preventDefault();
        setBusy(form, true);
        var errEl = form.querySelector('[data-ha-error]');
        if (errEl) errEl.hidden = true;
        var items = [{ id: Number(idInput.value), quantity: 1 }];
        checkedAddons().forEach(function (a) { items.push({ id: Number(a.dataset.variantId), quantity: 1 }); });
        var routes = cartRoutes();
        var wantsDrawer = action === 'cart' && !!document.querySelector('cart-drawer');
        var body = { items: items };
        if (wantsDrawer) {
          body.sections = 'cart-drawer,cart-icon-bubble';
          body.sections_url = window.location.pathname;
        }
        fetch(routes.add, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok || res.data.status) throw new Error((res.data && (res.data.description || res.data.message)) || 'Could not add to cart');
            if (action === 'checkout') { window.location.href = '/checkout'; return; }
            if (wantsDrawer && openDrawer(res.data)) { setBusy(form, false); return; }
            window.location.href = routes.cart;
          })
          .catch(function (err) {
            setBusy(form, false);
            showError(form, err.message || 'Something went wrong. Please try again.');
          });
      });
    });
  }

  /* ---------- product photo gallery (thumbs + swipe) ---------- */
  function initGallery(scope) {
    (scope || document).querySelectorAll('[data-ha-gallery]').forEach(function (g) {
      if (g.dataset.haBound) return;
      g.dataset.haBound = '1';
      var slides = Array.prototype.slice.call(g.querySelectorAll('[data-ha-slide]'));
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-ha-thumb]'));
      var current = 0;

      function show(i) {
        if (!slides.length) return;
        i = (i + slides.length) % slides.length;
        current = i;
        slides.forEach(function (sl, n) {
          var on = n === i;
          sl.hidden = !on;
          var v = sl.querySelector('video');
          if (v) { if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }
        });
        thumbs.forEach(function (t, n) {
          var on = n === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on && t.parentNode && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
            var box = t.parentNode;
            box.scrollTo({ left: t.offsetLeft - (box.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
          }
        });
      }

      g.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-ha-thumb]');
        if (!thumb) return;
        show(parseInt(thumb.dataset.haThumb, 10) || 0);
      });

      var main = g.querySelector('.ha-gallery__main');
      if (main && slides.length > 1) {
        var x0 = null, y0 = null;
        main.addEventListener('touchstart', function (e) {
          x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
        }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          var dy = e.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) show(current + (dx < 0 ? 1 : -1));
        }, { passive: true });
        main.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') show(current + 1);
          if (e.key === 'ArrowLeft') show(current - 1);
        });
      }
    });
  }

  function initAll(scope) {
    initReveal(scope);
    initSticky();
    initVariants();
    initCountdown();
    initVideos(scope);
    initAddons();
    initForms();
    initGallery(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: re-run when a section is added or edited.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  // Bring back pages restored from the back/forward cache with a clean button.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-ha-submit]').forEach(function (btn) {
      btn.removeAttribute('aria-busy');
      btn.style.pointerEvents = '';
    });
  });
})();
